export interface Testimonial {
  name: string;
  role: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "阿澈",
    role: "夜班编辑",
    content:
      "通勤路上刷了两年的悬案，第一次看到有人把时间线和各方说法排得这么清楚。不用自己再去拼碎片，读完直接能抓住关键。",
  },
  {
    name: "林小满",
    role: "大学生",
    content:
      "最喜欢都市传说那一栏，像是把小时候听过的故事重新整理了一遍。配图很有味道，不是那种吓人的血腥图，反而更耐看。",
  },
  {
    name: "老宋",
    role: "推理爱好者",
    content:
      "作为常年看悬案的人，很欣赏他们不轻易下结论的态度。每个推测都会标出它的漏洞，读起来比很多猎奇号靠谱太多。",
  },
  {
    name: "阿May",
    role: "深夜读者",
    content:
      "灵异杂谈的投稿板块意外地温柔，讲述者只是把经历说出来，没有夸张渲染。看完不会睡不着，反而有点安心的感觉。",
  },
  {
    name: "周野",
    role: "纪录片编导",
    content:
      "做选题调研时经常来翻档案，资料出处标注得比较完整，省了很多核实的功夫。希望以后能开放更多原始线索的索引。",
  },
  {
    name: "小满他哥",
    role: "程序员",
    content:
      "暗网那一栏把我吓了一跳，但读完发现是在理性拆解传闻，还顺带讲了钓鱼链接的识别方法，算是真的学到了东西。",
  },
];